(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kyndeo-product-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kyndeo-card')) {
    customElements.define('kyndeo-card', class extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;
        this.abortController = new AbortController();
        const selector = this.querySelector('[data-card-variant]');
        if (!selector) return;
        const update = () => {
          const selected = selector.selectedOptions[0];
          if (!selected) return;
          this.querySelector('[data-card-price]').textContent = selected.dataset.money;
          this.querySelector('[data-card-quantity]').value = selected.dataset.quantity || '1';
        };
        selector.addEventListener('change', update, { signal: this.abortController.signal });
        update();
      }
      disconnectedCallback() {
        this.abortController?.abort();
        this.abortController = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
